import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { FaArrowLeft } from "react-icons/fa"; // Removed unused FaFilePdf import
import AddingLightLoader from "../Loaders/AddingLightLoader";
import { fetchCustomerInvoice } from "../../store/Slices/CustomerInvoiceSlice";
import InvoicePDF from "./InvoicePDF"; // Ensure InvoicePDF is correctly exported
import { useReactToPrint } from "react-to-print";
import { fetchSuppliers } from "../../store/Slices/SupplierSlice";
import { ProductColumns } from "../../assets/Columns/ProductColumns";
import { fetchProducts } from "../../store/Slices/ProductSlice";

const ItemReport = () => {
  const dispatch = useDispatch();
  const ItemsState = useSelector((state) => state.ItemsState);

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchProducts());
  }, [dispatch]);

  const contentToPrint = useRef(null);
  const handlePrint = useReactToPrint({
    documentTitle: "Print This Document",
    onBeforePrint: () => console.log("before printing..."),
    onAfterPrint: () => console.log("after printing..."),
    removeAfterPrint: true,
  });

  const AmountTitleConverter = (amoutTitle) => {
    console.log(amoutTitle);

    switch (amoutTitle) {
      case "Payable":
        return "Remaining";
      case "Paid":
        return "Paid";
      case "Total":
        return "Total";
      default:
        return amoutTitle;
    }
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="mt-[12vh] flex items-center justify-center gap-x-3 relative w-full mb-10">
        <div
          className="border-2 border-ink px-2 py-2 rounded-full hover:text-white hover:bg-ink transition-colors ease-in-out duration-200 cursor-pointer absolute top-0 left-5"
          onClick={() => navigate(-1)}
        >
          <FaArrowLeft />
        </div>
        <button
          className="px-2 py-2 border-2 border-ink hover:rounded-lg transition-colors ease-in-out duration-200 hover:bg-ink/80 bg-ink text-white hover:text-white cursor-pointer w-[200px] flex justify-center items-center font-bold my-3"
          onClick={() => {
            handlePrint(null, () => contentToPrint.current, null);
          }}
        >
          PRINT
        </button>
      </div>

      <div ref={contentToPrint} className="flex flex-col w-auto p-1">
        <img
          src={`/banner.jpeg`}
          alt="banner"
          className="w-[100%] h-auto border-2 border-[#002650] rounded-t-lg"
        />
        {/* customer details */}
        <div className="flex w-full bg-main text-white justify-center items-center py-2 font-bold text-xl px-3 mt-1 font-quicksand">
          Items Report
        </div>

        {/* Invoice Items Table */}
        {ItemsState?.data?.length > 0 && (
          <div className="w-full overflow-x-auto mt-1">
            <table className="w-full text-left border-collapse border border-main">
              <thead className="bg-main text-white">
                <tr>
                  <th className="border border-main px-3 py-2 !w-[5px]">#</th>
                  {ProductColumns.filter(
                    (dt) => dt.id !== "actions" && dt.id !== "description"
                  ).map((dt, ci) => {
                    return (
                      <th
                        className={`border border-main px-3 py-2 whitespace-nowrap ${
                          ci === 0
                            ? "w-[150px]"
                            : ci === 1
                            ? "w-[180px]"
                            : ci === 2
                            ? "w-[210px]"
                            : ci === 3
                            ? "w-[100px]"
                            : ci === 4
                            ? "w-[80px]"
                            : ci === 5
                            ? "w-[80px]"
                            : ci === 6
                            ? "w-[95px]"
                            : "w-fit"
                        }`}
                      >
                        {["payable", "paid", "total"].includes(dt.id)
                          ? AmountTitleConverter(dt.title)
                          : dt.id === "in_qty"
                          ? "In Qty"
                          : dt.id === "out_qty"
                          ? "Out Qty"
                          : dt.id === "qty"
                          ? "Qty"
                          : dt.id === "sale"
                          ? "Price"
                          : dt.id === "sale_shop"
                          ? "S-Price"
                          : dt.title}
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {ItemsState.data.map((item, index) => (
                  <tr key={index} className="text-main">
                    <td className="border border-main px-3 py-2 !w-[5px]">
                      {index + 1}
                    </td>
                    {ProductColumns.filter(
                      (dt) => dt.id !== "actions" && dt.id !== "description"
                    ).map((dt) => {
                      return (
                        <td
                          className={`border border-main px-3 py-2 ${
                            ["payable", "paid", "total"].includes(dt.id) &&
                            "font-bold"
                          }`}
                        >
                          {["payable", "paid", "total"].includes(dt.id)
                            ? `Rs ${Number(item[dt.id]).toLocaleString(
                                "en-PK"
                              )}`
                            : dt.id === "companyId"
                            ? item.companyId.name
                            : item[dt.id]}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ItemReport;
